import * as React from "react";
import { BannerContainer, CardType } from "../../Components/BannerContainer";
import { NameView } from "../../Components/NameView";
import { PriceView, PriceUIType } from "../../Components/PriceView";
import { StarAndSold } from "../../Components/StarAndSold";
import { TwentyFour } from "../../Components/TwentyFour";
import { SingleCardWrap, Dec, BottomDec } from "./styles";
import { getInitProduct } from "../utils";
const SingleCard = (props) => {
    const { imgWidth, imgHeight, placeholderBg } = props;
    const { img, name, price, originPrice, url, ltImg, rtImg, sold, star, titleImg, twentyTour, countdownToEnd, } = getInitProduct(props.product);
    return (React.createElement(SingleCardWrap, { href: url },
        React.createElement(BannerContainer, { type: CardType.Single, imgWidth: imgWidth, imgHeight: imgHeight, banner: img, ltImg: ltImg, rtImg: rtImg, countdownToEnd: countdownToEnd, placeholderBg: placeholderBg }),
        React.createElement(Dec, null,
            React.createElement(NameView, { name: name, activeImg: titleImg }),
            React.createElement(PriceView, { type: PriceUIType.Large, price: price, originPrice: originPrice }),
            React.createElement(BottomDec, null,
                React.createElement(StarAndSold, { star: star, sold: sold }),
                React.createElement(TwentyFour, { text: twentyTour })))));
};
export default SingleCard;
